module.exports = __webpack_public_path__ + "img/globe-africa.47bccfeb.svg";